import React, { Fragment, useState } from 'react'
import '../../../../assets/css/pantalla1.css'
import '../../../../assets/css/analiticaCards.css'
import { Row, Col, Label } from 'reactstrap';
import { useSend } from '../../../../hooks/send/useSend';
import { ModalSendSamplings } from './ModalSendSamplings';
import DeniReactTreeView from "deni-react-treeview"
import 'animate.css';
import { Card } from 'primereact/card';
import { Avatar } from 'primereact/avatar';
import avatarHombre from '../../../../assets/images/user/hombre.png';
import avatarMujer from '../../../../assets/images/user/mujer.png';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';


export const IndexSend = () => {

    const {
        // * MODAL AND KEYS NIM
        typeSend, modalSend, openModal, closeModal, handleSendSample, nimAutoFocus, onKeyPressNim, getDataNim,
        handleSelectValuesNim, nim, handleInputChangeNim, loading,

        // * EXAM AND PROFILES
        treeviewRef, itemsTree, listNims, varSample, changeTree, saveSendSample, viewExams,

        // * NEW METHODS
        dataPatient, loadingView, loadindSend, nameBranch, showConfirmationToast, toastBC,
        focusNimEnabled,

        // * SEARCH TABLE PATIENT
        handleInfo, loadingInfor, customBody,
        globalFilter, setGlobalFilter, validSearch, setValidSearch, viewInfo, customBodyEstatus,
        validateToma


    } = useSend();

    const renderStatusLabel = (_find) => {

        let background = "#FFE0B2";
        let color = "#E65100";
        let text = "Sin muestra";
        let animate = false;
        let status = "warning";

        if (_find.state === 1 && _find.check_forwarded === false) {
            background = "#E8F5E9";
            color = "#2E7D32";
            text = "Con muestra";
            status = "success";
        }

        if (_find.state === 1 && _find.check_forwarded === true) {
            background = "#E3F2FD";
            color = "#1565C0";
            text = "Remitida";
            status = "forwarded";
        }

        if (_find.state !== 1) {
            animate = true;
        }

        return (
            <div
                style={{
                    background,
                    color,
                    fontSize: "11px",
                    fontWeight: 600,
                    padding: "4px 12px",
                    borderRadius: "20px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    minWidth: "120px",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    animation: animate ? "pulseSoft 3s ease-in-out infinite" : "none"
                }}
            >
                {status === "warning" && (
                    <i
                        className="pi pi-exclamation-triangle"
                        style={{ color: "#E65100", fontSize: "13px" }}
                    />
                )}

                {status === "success" && (
                    <i
                        className="pi pi-verified"
                        style={{ color: "#2E7D32", fontSize: "13px" }}
                    />
                )}

                {status === "forwarded" && (

                    <i className="icofont icofont-user"
                        style={{ color: "#1565C0", fontSize: "13px" }}></i>
                )}

                {text}
            </div>
        );
    };


    // ? CONFIGURATION CARDS INFO
    const onRenderItem = (_find) => {
        return (
            <div
                className="treeview-item-example"
                style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    gap: "10px"
                }}
            >
                <div
                    style={{
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }}
                >
                    <i
                        className="icofont icofont-laboratory f-12"
                        style={{
                            color:
                                _find.state === 1
                                    ? _find.check_forwarded
                                        ? "#1565C0"
                                        : "#51bb25"
                                    : "#FF8F00",
                            marginRight: "5px"
                        }}
                    />

                    <span
                        style={{
                            color:
                                _find.state === 1
                                    ? _find.check_forwarded
                                        ? "#1565C0"
                                        : "#51bb25"
                                    : "#FF8F00"
                        }}
                    >
                        {_find.text}
                    </span>
                </div>

                {_find.state === 1 && (
                    <div
                        style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center"
                        }}
                    >
                        {_find.is_send1 ? (
                            <i className="fa fa-check txt-success f-16" />
                        ) : (
                            <i className="fa fa-times text-danger f-16" />
                        )}

                        {_find.is_send2 ? (
                            <i className="fa fa-check txt-success f-16" />
                        ) : (
                            <i className="fa fa-times text-danger f-16" />
                        )}
                    </div>
                )}

                {_find.state !== 1 && (
                    <div>
                        {_find.valueDontSend === 1 ? (
                            <i className="icofont icofont-ui-block text-danger f-16" />
                        ) : _find.valueDontSend === 2 ? (
                            <i className="icofont icofont-ui-clock text-warning f-16" />
                        ) : (
                            <i className="icofont icofont-ui-block text-danger f-16" />
                        )}
                    </div>
                )}

                {renderStatusLabel(_find)}
            </div>
        );
    };

    const titlePatient = <>
        {
            dataPatient.length > 0 && dataPatient.map((_patient, index) => {
                const avatarImage = _patient?.gender === 2 ? avatarHombre : avatarMujer;
                return (
                    <Col key={index} sm="12">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                marginBottom: "15px"
                            }}
                        >
                            <div style={{ flex: 1 }} />

                            <Avatar
                                image={avatarImage}
                                size="xlarge"
                                shape="circle"
                            />

                            <div
                                style={{
                                    flex: 1,
                                    display: "flex",
                                    justifyContent: "flex-end"
                                }}
                            >
                                <Button
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#082d9d"
                                    }}
                                    label="Regresar"
                                    icon="pi pi-users"
                                    onClick={showConfirmationToast}
                                    severity="warning"
                                />

                                <Toast ref={toastBC} position="center" />
                            </div>
                        </div>

                        <Row>
                            <Col sm="3">
                                <label style={{ fontSize: "12px" }}>
                                    Nombre
                                    <br />
                                    {_patient?.name_patient ?? "---"}
                                </label>
                            </Col>

                            <Col sm="3">
                                <label style={{ fontSize: "12px" }}>
                                    Nim
                                    <br />
                                    {_patient?.nim ?? "---"}
                                </label>
                            </Col>

                            <Col sm="3">
                                <label style={{ fontSize: "12px" }}>
                                    Edad
                                    <br />
                                    {_patient?.age ?? "---"}
                                </label>
                            </Col>

                            <Col sm="3">
                                <label style={{ fontSize: "12px" }}>
                                    Fecha de ingreso
                                    <br />
                                    {_patient?.admision_date ?? "---"}
                                </label>
                            </Col>
                        </Row>
                    </Col>
                );
            })
        }
    </>;


    return (
        <Fragment  >
            <div >

                <Col xs="12" sm="12" md="12" lg="12" xl="12" className="">
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className=" p-l-0 p-r-0"> <br />
                            <div className='box-departamento-send'>
                                <Col sm="12" style={{ textAlign: "-webkit-center" }}>
                                    <Row>
                                        <Col xs="2" sm="2" md="2" lg="2" xl="2" className='p-l-0'>
                                            <Label className='labelToma1'></Label>
                                        </Col>
                                        <Col xs="9" sm="9" md="9" lg="9" xl="9">
                                            <label className='labelToma1'>
                                                {
                                                    varSample === false ? "Recibir Muestras" : "Envio de Muestras"
                                                }
                                            </label>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Col>

                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <Row>
                        <Col sm="12" md="5" lg="4" className='pt-0 pl-0 pr-0' >
                            <Card className='pt-0 pr-0' >
                                <Col sm="12" className='p-l-0 p-r-0'>
                                    <Row>
                                        <Col sm="10" className='p-r-0 p-l-0' >
                                            {
                                                varSample === false ?
                                                    <label style={{ fontSize: "13px" }} className='txt-info f-w-600' >Trabajo recibido en la sucursal <b style={{ color: "#1f4e69", fontSize: "13px" }} >  {nameBranch} </b> </label>
                                                    :
                                                    <label style={{ fontSize: "13px" }} className='txt-info f-w-600' >Trabajo enviado de la sucursal <b style={{ color: "#1f4e69", fontSize: "13px" }} >  {nameBranch} </b> </label>
                                            }
                                        </Col>
                                        <Col sm="1" className='p-l-0 pb-3'>
                                            {
                                                !validSearch && <Button
                                                    icon={validSearch ? "pi pi-times" : "pi pi-search"}
                                                    rounded
                                                    severity={validSearch ? "danger" : "success"}
                                                    aria-label="Search"
                                                    onClick={() => setValidSearch(!validSearch)}
                                                    style={{
                                                        padding: "5px 10px",
                                                        height: "35px",
                                                        width: "35px",
                                                        fontSize: "1rem",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                />
                                            }

                                        </Col>
                                    </Row>
                                    <Col sm="12" className='p-l-0 p-r-0'>
                                        <DataTable
                                            className="data-table compact-table"
                                            globalFilter={globalFilter}
                                            value={listNims}
                                            paginator
                                            rows={6}
                                            emptyMessage="No hay resultados disponibles."
                                            rowsPerPageOptions={[6, 12, 20, 30, 40, 50]}
                                            header={
                                                <Col sm="12" className={validSearch ? "p-l-0 p-r-0 pb-2" : "d-none"}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            width: "100%"
                                                        }}
                                                    >
                                                        <span
                                                            className="p-input-icon-left"
                                                            style={{
                                                                flex: 1
                                                            }}
                                                        >
                                                            <InputText
                                                                type="search"
                                                                className="pl-6"
                                                                placeholder="Buscar..."
                                                                onInput={(e) => setGlobalFilter(e.target.value)}
                                                                style={{
                                                                    width: "100%"
                                                                }}
                                                            />
                                                        </span>

                                                        <Button
                                                            icon={validSearch ? "pi pi-times" : "pi pi-search"}
                                                            rounded
                                                            severity={validSearch ? "danger" : "success"}
                                                            aria-label="Search"
                                                            onClick={() => setValidSearch(!validSearch)}
                                                            style={{
                                                                padding: "5px",
                                                                height: "35px",
                                                                width: "35px",
                                                                minWidth: "35px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                        >
                                            <Column
                                                field="nim"
                                                header="Nim"
                                                sortable
                                                body={customBody}
                                                bodyClassName="center-column"
                                            />

                                            <Column
                                                field="complete"
                                                header="Estatus"
                                                sortable
                                                body={customBodyEstatus}
                                                bodyClassName="center-column"
                                            />

                                            <Column
                                                field="created_at"
                                                header="Fecha de ingreso"
                                                sortable
                                            />

                                            <Column
                                                header="Acciones"
                                                bodyClassName="center-column"
                                                body={(rowData) => (
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            className="p-button p-button-success p-button-sm"
                                                            onClick={() => handleInfo(rowData.nim)}
                                                            title="Información"
                                                            style={{
                                                                border: "none",
                                                                background: "transparent",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            {
                                                                loadingInfor === rowData.nim
                                                                    ? (
                                                                        <i
                                                                            className="pi pi-spin pi-spinner"
                                                                            style={{
                                                                                fontSize: "12px",
                                                                                color: "green"
                                                                            }}
                                                                        />
                                                                    )
                                                                    : (
                                                                        <i
                                                                            className="pi pi-search"
                                                                            style={{
                                                                                fontSize: "12px",
                                                                                color: "green"
                                                                            }}
                                                                        />
                                                                    )
                                                            }
                                                        </button>
                                                    </div>
                                                )}
                                            />

                                        </DataTable>
                                    </Col>
                                </Col>
                            </Card>
                        </Col>
                        <Col sm="12" md="7" lg="8" style={{ textAlign: "center" }} className=' pt-0' >
                            <div style={{
                                position: 'absolute',
                                left: '-9999px',
                                top: '-9999px',
                                width: '1px',
                                height: '1px',
                                overflow: 'hidden',
                                zIndex: -1
                            }} className={validSearch ? "d-none" : "ocultar-input pt-0"}	>
                                <input
                                    id='inputFocusNim'
                                    autoFocus={focusNimEnabled}
                                    value={nim}
                                    onChange={(e) => handleSelectValuesNim(e.target.value, "nim")}
                                    onKeyDown={onKeyPressNim}
                                    onBlur={nimAutoFocus}
                                />
                            </div>
                            <Col sm="12" className={!viewExams ? "pt-0" : "d-none"}>
                                <div style={{ zIndex: 1 }}>
                                    <img className="" src={require("../../../../assetsToma/imagenes/Barras.gif")} style={{ width: "38%" }} alt="" />
                                </div>
                                <div className='a-line'>
                                    <label className='labelIniciarMuestra'>Escanea el <b className=''>Código de barras </b> de las muestras</label> <br />
                                </div>
                                <label className='labelCode'>o</label> <br />
                                <button className='bottonIniciarMuestra' style={{ backgroundColor: "#1f4e69" }} onClick={handleSendSample} > Ingresálo manualmente</button> <br /><br /><br />
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" className={viewExams === true ? "pt-0 pl-0 " : "d-none pt-0"} >
                                <Card title={titlePatient} subTitle="Estudios a realizar" className={loadingView ? "md:w-25rem pt-0 pl-0 " : false} >
                                    <Col sm="12" className='pl-0 pr-0' >
                                        <Row className='pl-0 p-r-0' >
                                            <Col sm="2">
                                            </Col>
                                            <Col sm="9">
                                                <DeniReactTreeView
                                                    ref={treeviewRef}
                                                    //showCheckbox={ loadindSend ?  false : true}
                                                    showCheckbox={false}
                                                    style={{
                                                        marginRight: '10px',
                                                        marginBottom: '10px',
                                                        height: "200px",
                                                        width: "100%",
                                                        textAlign: "center",
                                                        border: "2px solid #1f4e69",
                                                        borderRadius: "10px"
                                                    }}
                                                    showIcon={false}
                                                    items={itemsTree}
                                                    selectRow={false}
                                                    onRenderItem={onRenderItem}
                                                    onCheckItem={(e) => changeTree(e)}

                                                    className="deni-react-treeview-container.green .deni-react-treeview-item-container.green .icon-and-text.selected"
                                                />
                                                <br />
                                                {
                                                    !validateToma && <Button className={!viewInfo ? "d-none" : loadindSend ? "d-none" : ""} outline color='primary' size='sm' onClick={() => saveSendSample()} >Aceptar</Button>

                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                </Card>
                            </Col>
                        </Col>
                    </Row>
                </Col>
                <ModalSendSamplings
                    {
                    ...{
                        typeSend, modalSend, openModal, closeModal, getDataNim, handleSelectValuesNim, nim, handleInputChangeNim, loading
                    }
                    }
                />
            </div>
        </Fragment >
    )
}
